import { isAfter } from 'date-fns'

import config from '@acre/config'

export const getLatestCreditReportIdd = (documents: Maybe<DocumentEntity>[]) => {
  const creditIdds = documents.filter(
    (doc) => doc?.rendered_organisation_ids && doc.rendered_organisation_ids.includes(config.ACRE_SUPPORT_ORG_ID),
  ) as DocumentEntity[]

  if (creditIdds.length === 0) return undefined

  return creditIdds.reduce((latestCreditIdd, creditIdd) => {
    if (creditIdd?.date_stored && latestCreditIdd?.date_stored) {
      return isAfter(new Date(creditIdd.date_stored), new Date(latestCreditIdd.date_stored))
        ? creditIdd
        : latestCreditIdd
    } else if (!latestCreditIdd?.date_stored) {
      return creditIdd
    } else {
      return latestCreditIdd
    }
  })
}
